import React, { useState } from "react";
import { Box, TextField, Button, Typography, IconButton } from "@mui/material";
import { Add} from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  boxShadow: "none",
  color: theme.palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

const ExperienceDetailsForm = ({ onChildData }) => {
  const [experienceDetails, setExperienceDetails] = useState([
    {
      position: "",
      company: "",
      start_date: "",
      end_date: "",
      location: "",
      industry: "",
      key_responsibilities: [""],
      skills_acquired: [""],
    },
  ]);

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedExperience = [...experienceDetails];
    updatedExperience[index][name] = value;
    setExperienceDetails(updatedExperience);
    onChildData({experience_details: updatedExperience });
  };

  const handleKeyResponsibilitiesChange = (expIndex, respIndex, e) => {
    const { value } = e.target;
    const updatedExperience = [...experienceDetails];
    updatedExperience[expIndex].key_responsibilities[respIndex] = value;
    setExperienceDetails(updatedExperience);
    onChildData({experience_details: updatedExperience });
  };

  const handleSkillsChange = (expIndex, skillIndex, e) => {
    const { value } = e.target;
    const updatedExperience = [...experienceDetails];
    updatedExperience[expIndex].skills_acquired[skillIndex] = value;
    setExperienceDetails(updatedExperience);
    onChildData({experience_details: updatedExperience });
  };

  const addExperience = () => {
    setExperienceDetails([
      ...experienceDetails,
      {
        position: "",
        company: "",
        start_date: "",
        end_date: "",
        location: "",
        industry: "",
        key_responsibilities: [""],
        skills_acquired: [""],
      },
    ]);
  };

  const removeExperience = (index) => {
    const updatedExperience = experienceDetails.filter((_, i) => i !== index);
    setExperienceDetails(updatedExperience);
    onChildData({experience_details: updatedExperience });
  };

  

  const addKeyResponsibility = (index) => {
    const updatedExperience = [...experienceDetails];
    updatedExperience[index].key_responsibilities.push("");
    setExperienceDetails(updatedExperience);
    onChildData({experience_details: updatedExperience });
  };

  const removeKeyResponsibility = (expIndex, respIndex) => {
    const updatedExperience = [...experienceDetails];
    updatedExperience[expIndex].key_responsibilities = updatedExperience[
      expIndex
    ].key_responsibilities.filter((_, i) => i !== respIndex);
    setExperienceDetails(updatedExperience);
    onChildData({experience_details: updatedExperience });
  };

  const addSkill = (index) => {
    const updatedExperience = [...experienceDetails];
    updatedExperience[index].skills_acquired.push("");
    setExperienceDetails(updatedExperience);
    onChildData({experience_details: updatedExperience });
  };

  const removeSkill = (expIndex, skillIndex) => {
    const updatedExperience = [...experienceDetails];
    updatedExperience[expIndex].skills_acquired = updatedExperience[
      expIndex
    ].skills_acquired.filter((_, i) => i !== skillIndex);
    setExperienceDetails(updatedExperience);
    onChildData({experience_details: updatedExperience });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formattedOutput = `experience_details:\n${experienceDetails
      .map(
        (exp) =>
          `  - position: "${exp.position}"\n    company: "${
            exp.company
          }"\n    employment_period: "${exp.start_date} - ${
            exp.end_date
          }"\n    location: "${exp.location}"\n    industry: "${
            exp.industry
          }"\n    key_responsibilities:\n      - ${exp.key_responsibilities
            .map((res) => `"${res}"`)
            .join(
              "\n      - "
            )}\n    skills_acquired:\n      - ${exp.skills_acquired
            .map((skill) => `"${skill}"`)
            .join("\n      - ")}`
      )
      .join("\n")}`;

    console.log(formattedOutput);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ p: 3,pt:0,pb:2 }}>
      <Typography variant="h4" gutterBottom sx={{ display: "none" }}>
        Experience Details
      </Typography>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography variant="h6">Experience</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {experienceDetails.map((exp, expIndex) => (
            <Grid container spacing={2} key={expIndex} sx={{ mb: 2 }}>
              <Grid size={6}>
                <Item>
                  <TextField
                    fullWidth
                    label="Position"
                    placeholder="Software Engineer"
                    name="position"
                    size="small"
                    value={exp.position}
                    onChange={(e) => handleChange(expIndex, e)}
                    required
                  />
                </Item>
              </Grid>
              <Grid size={6}>
                <Item>
                  <TextField
                    fullWidth
                    label="Company"
                    name="company"
                    placeholder="Tech Innovations Inc."
                    size="small"
                    value={exp.company}
                    onChange={(e) => handleChange(expIndex, e)}
                    required
                  />
                </Item>
              </Grid>
              <Grid size={6}>
                <Item>
                  <TextField
                    fullWidth
                    label="Start Date"
                    name="start_date"
                    type="date"
                    size="small"
                    value={exp.start_date}
                    onChange={(e) => handleChange(expIndex, e)}
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Item>
              </Grid>
              <Grid size={6}>
                <Item>
                  <TextField
                    fullWidth
                    label="End Date"
                    name="end_date"
                    type="date"
                    size="small"
                    value={exp.end_date}
                    onChange={(e) => handleChange(expIndex, e)}
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Item>
              </Grid>
              <Grid size={12}>
                <Item>
                  <TextField
                    fullWidth
                    size="small"
                    label="Location"
                    placeholder="San Francisco, CA"
                    name="location"
                    value={exp.location}
                    onChange={(e) => handleChange(expIndex, e)}
                    required
                  />
                </Item>
              </Grid>
              <Grid size={9}>
                <Item>
                  <TextField
                    fullWidth
                    label="Industry"
                    name="industry"
                    size="small"
                    placeholder="Technology"
                    value={exp.industry}
                    onChange={(e) => handleChange(expIndex, e)}
                    required
                  />
                </Item>
              </Grid>
              <Grid size={3}>
                <Item>
                  <IconButton
                    onClick={() => removeExperience(expIndex)}
                    color="error"
                  >
                    <DeleteForeverIcon />
                  </IconButton>
                </Item>
              </Grid>
              <Grid size={12}>
                <Typography variant="h6" gutterBottom>
                  Key Responsibilities
                </Typography>
                {exp.key_responsibilities.map((resp, respIndex) => (
                  <div
                    key={respIndex}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "8px",
                    }}
                  >
                    <div style={{ flex: 1, marginRight: "8px" }}>
                      <TextField
                        fullWidth
                        label="Responsibility"
                        value={resp}
                        size="small"
                        placeholder="Developed web applications using React and Node.js"
                        onChange={(e) =>
                          handleKeyResponsibilitiesChange(
                            expIndex,
                            respIndex,
                            e
                          )
                        }
                        required
                      />
                    </div>
                    <div>
                      <IconButton
                        onClick={() =>
                          removeKeyResponsibility(expIndex, respIndex)
                        }
                        color="error"
                      >
                        <DeleteForeverIcon />
                      </IconButton>
                    </div>
                  </div>
                ))}
                <Button
                  variant="outlined"
                  onClick={() => addKeyResponsibility(expIndex)}
                  startIcon={<Add />}
                  sx={{ mb: 2 }}
                >
                  Add Responsibility
                </Button>
              </Grid>

              <Grid size={12}>
                <Typography variant="h6" gutterBottom>
                  Skills Acquired
                </Typography>
                {exp.skills_acquired.map((skill, skillIndex) => (
                  <div
                    key={skillIndex}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "8px",
                    }}
                  >
                    <div style={{ flex: 1, marginRight: "8px" }}>
                      <TextField
                        fullWidth
                        label="Skill"
                        value={skill}
                        size="small"
                        placeholder="React"
                        onChange={(e) =>
                          handleSkillsChange(expIndex, skillIndex, e)
                        }
                        required
                      />
                    </div>

                    <div>
                      <IconButton
                        onClick={() => removeSkill(expIndex, skillIndex)}
                        color="error"
                      >
                        <DeleteForeverIcon />
                      </IconButton>
                    </div>
                  </div>
                ))}
                <Button
                  variant="outlined"
                  onClick={() => addSkill(expIndex)}
                  startIcon={<Add />}
                  sx={{ mb: 2 }}
                >
                  Add Skill
                </Button>
              </Grid>
            </Grid>
          ))}
          <Button
            variant="outlined"
            onClick={addExperience}
            startIcon={<Add />}
            sx={{ mb: 2 }}
          >
            Add Experience
          </Button>
        </AccordionDetails>
      </Accordion>

      <Button type="submit" variant="contained" sx={{ display: "none" }}>
        Submit
      </Button>
    </Box>
  );
};

export default ExperienceDetailsForm;
